import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HistoricoSolicitacaoService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  // List all historico-solicitacao
  list(params?: any): Observable<any[]> {
    return this.apiService.get<{ data: any[] }>(`${this.path}`, params).pipe(
      map(response => response.data)
    );
  }

  // Create new historico-solicitacao
  store(historico: any): Observable<any> {
    return this.apiService.post<{ object: any }>(`${this.path}`, historico).pipe(
      map(response => response.object)
    );
  }

  // Update existing historico-solicitacao
  update(historico: any): Observable<any> {
    return this.apiService.put<{ object: any }>(`${this.path}`, historico).pipe(
      map(response => response.object)
    );
  }

  // Delete existing historico-solicitacao
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/${id}`);
  }

  // Get historico-solicitacao by ID
  show(id: string): Observable<any> {
    return this.apiService.get<{ object: any }>(`${this.path}/${id}`).pipe(
      map(response => response.object)
    );
  }
}
